import { render, staticRenderFns } from "./view.html?vue&type=template&id=cba07544&scoped=true&"
import script from "./script.js?vue&type=script&lang=js&"
export * from "./script.js?vue&type=script&lang=js&"
import style0 from "./homestyle.less?vue&type=style&index=0&id=cba07544&lang=less&scoped=true&"
import style1 from "./homestyle_mobile.less?vue&type=style&index=1&id=cba07544&lang=less&scoped=true&"
import style2 from "./otherstyle.less?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cba07544",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cba07544')) {
      api.createRecord('cba07544', component.options)
    } else {
      api.reload('cba07544', component.options)
    }
    module.hot.accept("./view.html?vue&type=template&id=cba07544&scoped=true&", function () {
      api.rerender('cba07544', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/box/mine/index.vue"
export default component.exports